/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: PX6_ceQKCHMf
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot,
  useCurrentUser
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicTabInTab.module.css"; // plasmic-import: PX6_ceQKCHMf/css

createPlasmicElementProxy;

export const PlasmicTabInTab__VariantProps = new Array();

export const PlasmicTabInTab__ArgProps = new Array("tabNav", "tabContent");

const $$ = {};

function PlasmicTabInTab__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root
      )}
    >
      <div
        data-plasmic-name={"wrappWithBorder"}
        data-plasmic-override={overrides.wrappWithBorder}
        className={classNames(projectcss.all, sty.wrappWithBorder)}
      >
        <div
          data-plasmic-name={"slotTabNav"}
          data-plasmic-override={overrides.slotTabNav}
          className={classNames(projectcss.all, sty.slotTabNav)}
        >
          {renderPlasmicSlot({
            defaultContents: null,
            value: args.tabNav
          })}
        </div>
        <div
          data-plasmic-name={"slotTabContent"}
          data-plasmic-override={overrides.slotTabContent}
          className={classNames(projectcss.all, sty.slotTabContent)}
        >
          {renderPlasmicSlot({
            defaultContents: null,
            value: args.tabContent
          })}
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "wrappWithBorder", "slotTabNav", "slotTabContent"],
  wrappWithBorder: ["wrappWithBorder", "slotTabNav", "slotTabContent"],
  slotTabNav: ["slotTabNav"],
  slotTabContent: ["slotTabContent"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTabInTab__ArgProps,
          internalVariantPropNames: PlasmicTabInTab__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTabInTab__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicTabInTab";
  } else {
    func.displayName = `PlasmicTabInTab.${nodeName}`;
  }
  return func;
}

export const PlasmicTabInTab = Object.assign(
  // Top-level PlasmicTabInTab renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    wrappWithBorder: makeNodeComponent("wrappWithBorder"),
    slotTabNav: makeNodeComponent("slotTabNav"),
    slotTabContent: makeNodeComponent("slotTabContent"),
    // Metadata about props expected for PlasmicTabInTab
    internalVariantProps: PlasmicTabInTab__VariantProps,
    internalArgProps: PlasmicTabInTab__ArgProps
  }
);

export default PlasmicTabInTab;
/* prettier-ignore-end */
